import { SVGAttributes } from 'react'
const id = 'add-icon'
const AddIcon = (props: SVGAttributes<SVGElement>) => (
    <svg fill={props.color || 'white'} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
        <defs>
            <linearGradient x1="0%" y1="10%" x2="0%" y2="90%" id={props.id || id}>
                <stop id="gradient-stop-1" offset="0%" stopColor="var(--stop-color-1)" />
                <stop id="gradient-stop-2" offset="100%" stopColor="var(--stop-color-2)" />
            </linearGradient>
        </defs>
        <path
            fill={props.className?.indexOf('--stop-color-1') === -1 ? '' : `url(#${props.id || id})`}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.27273 0C7.72044 0 7.27273 0.447715 7.27273 1V7.27273L1 7.27273C0.447716 7.27273 0 7.72044 0 8.27273V11.7273C0 12.2796 0.447716 12.7273 1 12.7273H7.27273V19C7.27273 19.5523 7.72044 20 8.27273 20H11.7273C12.2796 20 12.7273 19.5523 12.7273 19V12.7273H19C19.5523 12.7273 20 12.2796 20 11.7273V8.27273C20 7.72044 19.5523 7.27273 19 7.27273L12.7273 7.27273V1C12.7273 0.447715 12.2796 0 11.7273 0H8.27273Z"
        />
    </svg>
)
export default AddIcon
